export default {
  name: 'Business proposal',
  preview: 'https://cdn.affine.pro/templates/cover/business-proposal.png',
  type: 'template',
  assets: {
    '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=':
      'https://cdn.affine.pro/templates/assets/5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=.png',
    'lpuHEpaVee9JQg04FPMvGyDQKaoOpGgJPcRr9esXX6c=':
      'https://cdn.affine.pro/templates/assets/lpuHEpaVee9JQg04FPMvGyDQKaoOpGgJPcRr9esXX6c=.png',
    'MU7nFyWxQZGbxJcgcMk51gPOniw0APZZz8QwibMv63I=':
      'https://cdn.affine.pro/templates/assets/MU7nFyWxQZGbxJcgcMk51gPOniw0APZZz8QwibMv63I=.png',
    'sStrDiHGmJI0fL_tOOKD5or4xGVdEAkjORUhOquQqm4=':
      'https://cdn.affine.pro/templates/assets/sStrDiHGmJI0fL_tOOKD5or4xGVdEAkjORUhOquQqm4=.png',
    'X6sT_Av1ACadZUhAcnlHNg3qzYg508fFM0AXT13gaZg=':
      'https://cdn.affine.pro/templates/assets/X6sT_Av1ACadZUhAcnlHNg3qzYg508fFM0AXT13gaZg=.png',
    'YRK8H80QGFrLa_vsRf7DIwEYnPsf2v10Ed39rl4UEyo=':
      'https://cdn.affine.pro/templates/assets/YRK8H80QGFrLa_vsRf7DIwEYnPsf2v10Ed39rl4UEyo=.png',
  },
  content: {
    type: 'page',
    meta: {
      id: 'page:I5WoYKp4Uc',
      title: '',
      createDate: 1702627715424,
      tags: [],
    },
    blocks: {
      type: 'block',
      id: 'block:0WwhZofppy',
      flavour: 'affine:page',
      props: {
        title: {
          '$blocksuite:internal:text$': true,
          delta: [],
        },
      },
      children: [
        {
          type: 'block',
          id: 'block:cZnyeEzUiq',
          flavour: 'affine:surface',
          props: {
            elements: {
              v1xvpqdc9h: {
                type: 'shape',
                xywh: '[5000.422168588957,825.2166135235592,1489.8866704714924,25.74013173888693]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0.1,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'v1xvpqdc9h',
                index: 'a4',
                seed: 305892425,
                color: '--affine-palette-line-black',
              },
              'xYeHY-MRWp': {
                type: 'shape',
                xywh: '[5471.449031000489,803.8661563746741,59.49757789928316,59.49757789928303]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-white',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                id: 'xYeHY-MRWp',
                index: 'a6',
                seed: 459940732,
                color: '--affine-palette-line-black',
              },
              xfSptKTgpb: {
                type: 'shape',
                xywh: '[5801.276777531035,803.8661563746741,59.49757789928316,59.49757789928303]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-white',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                id: 'xfSptKTgpb',
                index: 'a7',
                seed: 814009913,
                color: '--affine-palette-line-black',
              },
              dwRGwjh1Uy: {
                type: 'shape',
                xywh: '[6131.104524061582,803.8661563746741,59.49757789928316,59.49757789928303]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-white',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                id: 'dwRGwjh1Uy',
                index: 'a8',
                seed: 983459874,
                color: '--affine-palette-line-black',
              },
              uT4YleA06R: {
                type: 'shape',
                xywh: '[5069.948263232722,372.89673468264266,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'uT4YleA06R',
                index: 'a9',
                seed: 1169166239,
                color: '--affine-palette-line-black',
              },
              ZmzLjgkT7N: {
                type: 'shape',
                xywh: '[5399.776009763269,372.89673468264266,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'ZmzLjgkT7N',
                index: 'aA',
                seed: 1745087278,
                color: '--affine-palette-line-black',
              },
              '3zerHIqE-_': {
                type: 'shape',
                xywh: '[5729.603756293816,372.89673468264266,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: '3zerHIqE-_',
                index: 'aB',
                seed: 835374136,
                color: '--affine-palette-line-black',
              },
              'D-JDT7SAkW': {
                type: 'shape',
                xywh: '[6059.431502824364,372.89673468264266,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'D-JDT7SAkW',
                index: 'aC',
                seed: 24543409,
                color: '--affine-palette-line-black',
              },
              '0ndsfTZ0SM': {
                type: 'connector',
                mode: 0,
                strokeWidth: 4,
                stroke: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                source: {
                  id: 'ZmzLjgkT7N',
                  position: [0.5, 1],
                },
                target: {
                  id: 'xYeHY-MRWp',
                  position: [0.49999999999999856, 0],
                },
                id: '0ndsfTZ0SM',
                index: 'aE',
                seed: 752582912,
                rearEndpointStyle: 'None',
                xywh: '[5500.65989513016,574.6645054164248,1,229.20165095824927]',
              },
              YeoLxRuHuK: {
                type: 'connector',
                mode: 0,
                strokeWidth: 4,
                stroke: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                source: {
                  id: '3zerHIqE-_',
                  position: [0.5, 1],
                },
                target: {
                  id: 'xfSptKTgpb',
                  position: [0.49999999999999856, 0],
                },
                id: 'YeoLxRuHuK',
                index: 'aF',
                seed: 1151046539,
                rearEndpointStyle: 'None',
                xywh: '[5830.487641660708,574.6645054164248,1,229.20165095824927]',
              },
              ob7kW7BjVm: {
                type: 'connector',
                mode: 0,
                strokeWidth: 4,
                stroke: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                source: {
                  id: 'D-JDT7SAkW',
                  position: [0.5, 1],
                },
                target: {
                  id: 'dwRGwjh1Uy',
                  position: [0.49999999999999856, 0],
                },
                id: 'ob7kW7BjVm',
                index: 'aG',
                seed: 645414812,
                rearEndpointStyle: 'None',
                xywh: '[6160.315388191255,574.6645054164248,1,229.20165095824927]',
              },
              CQohD_ZThx: {
                type: 'text',
                xywh: '[6129.315388191255,292.96623946912683,64,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '2023',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 40,
                fontFamily: 'blocksuite:surface:BebasNeue',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'CQohD_ZThx',
                index: 'aL',
                seed: 1074040389,
              },
              I4YKY24gN9: {
                type: 'text',
                xywh: '[5799.487641660708,292.96623946912683,65,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '2022',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 40,
                fontFamily: 'blocksuite:surface:BebasNeue',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'I4YKY24gN9',
                index: 'aM',
                seed: 8316108,
              },
              pVGTk_m5AZ: {
                type: 'text',
                xywh: '[5469.15989513016,292.96623946912683,65,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '2021',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 40,
                fontFamily: 'blocksuite:surface:BebasNeue',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'pVGTk_m5AZ',
                index: 'aN',
                seed: 1075416576,
              },
              _L7CwtDFEA: {
                type: 'text',
                xywh: '[5139.332148599613,292.96623946912683,65,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '2020',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 40,
                fontFamily: 'blocksuite:surface:BebasNeue',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '_L7CwtDFEA',
                index: 'aO',
                seed: 2084020856,
              },
              '9TjB6In1l4': {
                type: 'text',
                xywh: '[5129.431605386722,902.1407030686689,84.80108642578125,28.5]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Stage 1',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'center',
                id: '9TjB6In1l4',
                index: 'aP',
                seed: 1010267648,
              },
              '5ewjK533rs': {
                type: 'text',
                xywh: '[5046.332148599613,949.1098529022973,251,46]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this milestone',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                id: '5ewjK533rs',
                index: 'aT',
                seed: 8255043,
                hasMaxWidth: true,
              },
              KrkIty49VK: {
                type: 'text',
                xywh: '[5456.719480503916,902.1407030686689,90,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Stage 2',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24.03372713795044,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'center',
                id: 'KrkIty49VK',
                index: 'aU',
                seed: 756916496,
              },
              oLXXWv1qS6: {
                type: 'text',
                xywh: '[5376.15989513016,949.1098529022973,251,46]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this milestone',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                id: 'oLXXWv1qS6',
                index: 'aV',
                seed: 1154790041,
                hasMaxWidth: true,
              },
              KOCiPVB86q: {
                type: 'text',
                xywh: '[5786.987641660708,902.1407030686689,90,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Stage 3',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'center',
                id: 'KOCiPVB86q',
                index: 'aW',
                seed: 1417903226,
              },
              sVjzVX7Axf: {
                type: 'text',
                xywh: '[5706.487641660708,949.1098529022973,251,46]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this milestone',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                id: 'sVjzVX7Axf',
                index: 'aX',
                seed: 1239190195,
                hasMaxWidth: true,
              },
              'YEEQSfL1-A': {
                type: 'text',
                xywh: '[6115.815388191255,902.1407030686689,91,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Stage 4',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'center',
                id: 'YEEQSfL1-A',
                index: 'aY',
                seed: 958096200,
              },
              '63FSPgYdia': {
                type: 'text',
                xywh: '[6035.815388191255,949.1098529022973,251,46]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this milestone',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                id: '63FSPgYdia',
                index: 'aZ',
                seed: 1615318817,
                hasMaxWidth: true,
              },
              'vl-yYaqfk_': {
                type: 'shape',
                xywh: '[3686.5329269060107,1318.880372533908,636.1053294230119,636.1053294230111]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: false,
                fillColor: '--affine-palette-transparent',
                strokeWidth: 6,
                strokeColor: '--affine-palette-line-purple',
                strokeStyle: 'dash',
                roughness: 1.4,
                id: 'vl-yYaqfk_',
                index: 'Zv',
                seed: 1659149041,
                color: '--affine-palette-line-black',
              },
              CzquHF_9av: {
                type: 'shape',
                xywh: '[4140.804251934269,1337.295248548868,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'CzquHF_9av',
                index: 'Zw',
                seed: 1770583176,
                color: '--affine-palette-line-black',
              },
              KPL0SHH3PV: {
                type: 'shape',
                xywh: '[3597.306157602888,1548.3102125373161,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'KPL0SHH3PV',
                index: 'Zx',
                seed: 214183508,
                color: '--affine-palette-line-black',
              },
              'KRg-Xo0ahC': {
                type: 'shape',
                xywh: '[4168.497971764953,1706.2487813895084,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'KRg-Xo0ahC',
                index: 'Zy',
                seed: 289841896,
                color: '--affine-palette-line-black',
              },
              RCIKCZ3oA5: {
                type: 'shape',
                xywh: '[3833.0343812020524,1821.6326667563994,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'RCIKCZ3oA5',
                index: 'Zz',
                seed: 1649477631,
                color: '--affine-palette-line-black',
              },
              xzO3Re2zx2: {
                type: 'shape',
                xywh: '[3785.5343812020524,1245.9582031568575,201.76777073378275,201.76777073378219]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'xzO3Re2zx2',
                index: 'aM',
                seed: 1480225366,
                color: '--affine-palette-line-black',
              },
              lIYMQyzF5Q: {
                type: 'text',
                xywh: '[4370.265742498736,1370.4064691041553,89,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'lIYMQyzF5Q',
                index: 'aO',
                seed: 950898437,
              },
              NRglpdgd8B: {
                type: 'text',
                xywh: '[4370.265742498736,1410.6564691041553,251,43]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'NRglpdgd8B',
                index: 'aP',
                seed: 1312674817,
                hasMaxWidth: true,
              },
              nkCc3l9dbO: {
                type: 'text',
                xywh: '[4438.420057133606,1808.3670054292957,251,43]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'nkCc3l9dbO',
                index: 'aQ',
                seed: 2146196367,
                hasMaxWidth: true,
              },
              ruONHiRlQ9: {
                type: 'text',
                xywh: '[4438.420057133606,1768.1170054292957,89,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'ruONHiRlQ9',
                index: 'aR',
                seed: 1704267176,
              },
              '2Lj16Rr0aU': {
                type: 'text',
                xywh: '[3513.132650596946,1968.6415521232907,251,43]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '2Lj16Rr0aU',
                index: 'aS',
                seed: 547147214,
                hasMaxWidth: true,
              },
              AxehWJn9EF: {
                type: 'text',
                xywh: '[3513.132650596946,1928.3915521232907,89,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'AxehWJn9EF',
                index: 'aT',
                seed: 623768655,
              },
              '-MJyB_VljN': {
                type: 'text',
                xywh: '[3318.503605896128,1647.8190979042072,251,43]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '-MJyB_VljN',
                index: 'aU',
                seed: 1275218579,
                hasMaxWidth: true,
              },
              OCmVwXzMdy: {
                type: 'text',
                xywh: '[3318.503605896128,1607.5690979042072,89,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'OCmVwXzMdy',
                index: 'aV',
                seed: 1314725710,
              },
              QHyUiYq2F5: {
                type: 'text',
                xywh: '[3462.114720377512,1297.4670885237485,251,43]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'This paragraph provides an introduction to this section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'QHyUiYq2F5',
                index: 'aW',
                seed: 1533504434,
                hasMaxWidth: true,
              },
              guoX5PU9Eb: {
                type: 'text',
                xywh: '[3462.114720377512,1257.2170885237485,89,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Section',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'guoX5PU9Eb',
                index: 'aX',
                seed: 1493386392,
              },
              wFZuI2RLrD: {
                type: 'shape',
                xywh: '[4286.389648704759,431.35771818739454,391.1040508877638,523.9554856361598]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0.1,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'wFZuI2RLrD',
                index: 'b00',
                seed: 94745286,
                color: '--affine-palette-line-black',
              },
              'o1HC86BOS-': {
                type: 'shape',
                xywh: '[3809.0335661736353,431.35771818739454,391.1040508877638,523.9554856361598]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0.1,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'o1HC86BOS-',
                index: 'b00',
                seed: 1688028921,
                color: '--affine-palette-line-black',
              },
              Ac8dO1IgZz: {
                type: 'shape',
                xywh: '[3331.677483642512,431.35771818739454,391.1040508877638,523.9554856361598]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0.1,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'Ac8dO1IgZz',
                index: 'b00',
                seed: 1661884164,
                color: '--affine-palette-line-black',
              },
              vUR_wqR8AS: {
                type: 'text',
                xywh: '[3331.677483642512,283.03415541289723,85.51995849609375,56]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Title',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 40,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'vUR_wqR8AS',
                index: 'b00',
                seed: 1815365591,
              },
              '-rpQwCGOAB': {
                type: 'text',
                xywh: '[3331.677483642512,347.3953759681849,1340,43]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 18,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '-rpQwCGOAB',
                index: 'b00',
                seed: 1590226083,
                hasMaxWidth: true,
              },
              bNwmKzRCmU: {
                type: 'shape',
                xywh: '[5141.083359649972,803.8661563746741,59.49757789928316,59.49757789928303]',
                rotate: 0,
                shapeType: 'ellipse',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-white',
                strokeWidth: 12,
                strokeColor: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                id: 'bNwmKzRCmU',
                index: 'b02',
                seed: 1486989012,
                color: '--affine-palette-line-black',
              },
              BM8xW6eKdu: {
                type: 'connector',
                mode: 1,
                strokeWidth: 4,
                stroke: '--affine-palette-line-purple',
                strokeStyle: 'solid',
                roughness: 1.4,
                source: {
                  id: 'bNwmKzRCmU',
                  position: [0.5, 0],
                },
                target: {
                  id: 'uT4YleA06R',
                  position: [0.49999999999999944, 1],
                },
                id: 'BM8xW6eKdu',
                index: 'b03',
                seed: 1681229764,
                rearEndpointStyle: 'None',
                xywh: '[5170.828969860392,574.6664677358267,1,229.20000000000005]',
              },
              'Rb4Jma-7qE': {
                type: 'shape',
                xywh: '[5023.469273798737,1319.6581535468417,447.3486346230511,652.2827693553795]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0.1,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-orange',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'Rb4Jma-7qE',
                index: 'b2a',
                seed: 2052058894,
                color: '--affine-palette-line-black',
              },
              byS9LTkHp4: {
                type: 'text',
                xywh: '[5578.2184401639515,1357.0722118584613,284,73]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Summaries',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 48,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'byS9LTkHp4',
                index: 'b2b',
                seed: 2002337178,
              },
              oshK6MXv4M: {
                type: 'text',
                xywh: '[5978.487655891084,1518.2294202053827,286.2980768176762,168]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'Get the word out on social media! Social media is a powerful tool to reach people across the globe. Share your tips with your followers and encourage others to do the same.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 20,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'oshK6MXv4M',
                index: 'b2c',
                seed: 1253755023,
                hasMaxWidth: true,
              },
              tzyzLRtZbi: {
                type: 'text',
                xywh: '[5978.487655891084,1472.0307951295272,39,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '02.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'tzyzLRtZbi',
                index: 'b2d',
                seed: 2046423432,
              },
              KNgldlE2kB: {
                type: 'text',
                xywh: '[5589.8159549422035,1790.5268645906012,286.2980768176762,144]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'Join a community group that focuses on reducing plastic use and work together on ways to inform your community on how to reduce plastic use.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 20,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'KNgldlE2kB',
                index: 'b2e',
                seed: 503936602,
                hasMaxWidth: true,
              },
              Lk6esPrFki: {
                type: 'text',
                xywh: '[5589.8159549422035,1738.3282395147448,39,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '03.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'Lk6esPrFki',
                index: 'b2f',
                seed: 1972591908,
              },
              UDBOSIyCCQ: {
                type: 'text',
                xywh: '[5589.8159549422035,1518.2294202053827,286.2980768176762,72]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'Inform your friends and family of ways they can reduce their plastic use.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 20,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'UDBOSIyCCQ',
                index: 'b2g',
                seed: 1543577967,
                hasMaxWidth: true,
              },
              Q7xttKjesV: {
                type: 'text',
                xywh: '[5589.8159549422035,1472.0307951295272,35,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '01.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'Q7xttKjesV',
                index: 'b2h',
                seed: 695140097,
              },
              jvvoNcvB4h: {
                type: 'text',
                xywh: '[5978.487655891084,1790.5268645906012,286.2980768176762,120]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'Stay informed on progress. Keep up to date on changes in your community or state and be aware of decreases in progress.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 20,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'jvvoNcvB4h',
                index: 'b2i',
                seed: 713746367,
                hasMaxWidth: true,
              },
              aGjicymxSj: {
                type: 'text',
                xywh: '[5978.487655891084,1738.3282395147448,39,29]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: '04.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 24,
                fontFamily: 'blocksuite:surface:Inter',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'aGjicymxSj',
                index: 'b2j',
                seed: 1958232302,
              },
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:FfMzOl9AxI',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Timeline',
                    },
                  ],
                },
                background: '--affine-tag-purple',
                xywh: '[4890.30883906045,167.35261121180537,1600,900]',
                index: 'a0',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:DCdSxTLOn3',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'MU7nFyWxQZGbxJcgcMk51gPOniw0APZZz8QwibMv63I=',
                width: 0,
                height: 0,
                index: 'aH',
                xywh: '[5453.15989513016,426.28062004953375,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:h_wqUAmzzW',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'lpuHEpaVee9JQg04FPMvGyDQKaoOpGgJPcRr9esXX6c=',
                width: 0,
                height: 0,
                index: 'aI',
                xywh: '[5123.832148599613,426.28062004953375,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:KDnP-OBZsY',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'sStrDiHGmJI0fL_tOOKD5or4xGVdEAkjORUhOquQqm4=',
                width: 0,
                height: 0,
                index: 'aJ',
                xywh: '[6112.815388191253,426.28062004953375,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:xILeUxeiAS',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'YRK8H80QGFrLa_vsRf7DIwEYnPsf2v10Ed39rl4UEyo=',
                width: 0,
                height: 0,
                index: 'aK',
                xywh: '[5782.987641660708,426.28062004953375,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:gwZLEptQ3T',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Cycle',
                    },
                  ],
                },
                background: '--affine-tag-purple',
                xywh: '[3196.8433476963087,1184.0748043403794,1600,900]',
                index: 'a1',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:7ZhlE4GjyJ',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'MU7nFyWxQZGbxJcgcMk51gPOniw0APZZz8QwibMv63I=',
                width: 0,
                height: 0,
                index: 'aP',
                xywh: '[3650.6900429697794,1601.6940979042072,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:ibxjd1TYLF',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'lpuHEpaVee9JQg04FPMvGyDQKaoOpGgJPcRr9esXX6c=',
                width: 0,
                height: 0,
                index: 'aQ',
                xywh: '[4194.688137301162,1390.679133915759,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:5UbuR2d7y4',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'sStrDiHGmJI0fL_tOOKD5or4xGVdEAkjORUhOquQqm4=',
                width: 0,
                height: 0,
                index: 'aR',
                xywh: '[3886.4182665689436,1875.0165521232907,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:sC38fxJ_gX',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'YRK8H80QGFrLa_vsRf7DIwEYnPsf2v10Ed39rl4UEyo=',
                width: 0,
                height: 0,
                index: 'aS',
                xywh: '[4221.881857131846,1759.6326667563994,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:sO4f7yykIi',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'X6sT_Av1ACadZUhAcnlHNg3qzYg508fFM0AXT13gaZg=',
                width: 0,
                height: 0,
                index: 'aT',
                xywh: '[3838.9182665689436,1297.4670885237485,95,95]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:nDvIKUIUsk',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Story',
                    },
                  ],
                },
                background: '--affine-tag-purple',
                xywh: '[3196.8433476963087,167.35261121180537,1600,900]',
                index: 'a4',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:ylRVGRlX4r',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'b2X',
                xywh: '[3913.8322792330237,602.5821486209802,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:fX8BzaxCUH',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'b2Y',
                xywh: '[4391.188361764147,602.5821486209802,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:u2Qt3LCs90',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'b01',
                xywh: '[3436.4761967018985,602.5821486209802,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:mDNgKTE-4u',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Summaries',
                    },
                  ],
                },
                background: '--affine-tag-purple',
                xywh: '[4890.30883906045,1184.0748043403794,1600,900]',
                index: 'a5',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:Y_wwmdtGzO',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'b2k',
                xywh: '[5156.390278725768,1555.0462258400376,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
          ],
        },
      ],
    },
  },
};
